import React from "react";
import DataTable from "../DataTable/DataTable";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import Switch from "../Switch/Switch";
import Tabs from "../Tabs/Tabs";

class ChannelBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      active_tab: "general",
      channel_rate_room_types: this.props.channel_rate_room_types,
      loading: false,
      rate_id: this.props.rate_id || "",
      room_type_id: this.props.room_type_id || "",
      wihp_enabled:
        typeof this.props.wihp_enabled !== "undefined"
          ? this.props.wihp_enabled
          : true,
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this);
    this.onChangeDefault = this.onChangeDefault.bind(this);
    this.onChangeDisabled = this.onChangeDisabled.bind(this);
  }

  render() {
    const tabs = this.getTabs();
    return (
      <div className="ChannelBuilder">
        <Tabs tabs={tabs} />
        {this.renderDefaultRateAndRoomTypeForm()}
        {this.state.active_tab === "general"
          ? this.renderGeneralTab(tabs)
          : null}
        {this.state.active_tab === "logs" ? (
          <div className="logs">
            <div className="row">
              <div className="col-md-12">
                <DataTable
                  endpoint={this.props.channel_logs_data_table_path}
                  no_data_text={I18n.t("none")}
                  currency_unit={I18n.t("number.currency.format.unit")}
                  delimiter={I18n.t("number.currency.format.delimiter")}
                  separator={I18n.t("number.currency.format.separator")}
                  date_format={this.props.date_format}
                  time_format={this.props.time_format}
                  model_name={"ChannelLog"}
                />
              </div>
            </div>
          </div>
        ) : null}
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  renderGeneralTab(tabs) {
    if (this.props.name === "WIHP") {
      return (
        <div className="is_tab">
          <div className="panel panel-default">
            <div className="panel-body">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group" style={{ marginBottom: 0 }}>
                    <label>{I18n.t("wihp_integration_enabled")}</label>
                    <br />
                    {this.props.wihp_active ? I18n.t("yes") : I18n.t("no")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <table
          className={`table table-bordered ${tabs.length ? "has-tabs" : ""}`}
        >
          <tbody>
            {this.renderRoomTypesRows()}
            {this.renderRateRows()}
          </tbody>
        </table>
      );
    }
  }

  renderDefaultRateAndRoomTypeForm() {
    if (
      this.props.default_rate_and_room_type_enabled &&
      this.props.name !== "WIHP" &&
      this.props.name !== "website"
    ) {
      return (
        <div className="panel panel-default">
          <div className="panel-body" style={{ padding: 20 }}>
            <div className="row">
              <div className="col-sm-6">
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>
                    {I18n.t("default_rate")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("channel_default_rate_helper_text")}
                    ></span>
                  </label>
                  <select
                    className="form-control"
                    name="rate_id"
                    onChange={this.onChange}
                    value={this.state.rate_id}
                  >
                    <option value="">{I18n.t("please_select")}</option>
                    {this.props.rates.map((rate) => {
                      return (
                        <option key={rate.id} value={rate.id}>
                          {rate.code} ({rate.name})
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="form-group" style={{ marginBottom: 0 }}>
                  <label>
                    {I18n.t("default_room_type")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("channel_default_room_type_helper_text")}
                    ></span>
                  </label>
                  <select
                    className="form-control"
                    name="room_type_id"
                    onChange={this.onChange}
                    value={this.state.room_type_id}
                  >
                    <option value="">{I18n.t("please_select")}</option>
                    {this.props.room_types.map((room_type) => {
                      return (
                        <option key={room_type.id} value={room_type.id}>
                          {room_type.code} ({room_type.name})
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  renderRoomTypesRows() {
    var cols = this.props.room_types.map(function (room_type) {
      return (
        <th key={room_type.id} className="room_type">
          {room_type.code} ({room_type.name})
        </th>
      );
    });

    cols.unshift(
      <th key="blank" className="blank">
        &nbsp;
      </th>
    ); // blank first col

    return <tr>{cols}</tr>;
  }

  renderRateRows() {
    var self = this;

    var rows = this.props.rates.map(function (rate) {
      var cols = self.props.room_types.map(function (room_type) {
        var channel_rate_room_type = self.getChannelRateRoomType(
          rate.id,
          room_type.id
        );
        return (
          <td
            key={room_type.id}
            className={
              (channel_rate_room_type &&
              channel_rate_room_type.status != "disabled"
                ? " "
                : "disabled-channel ") +
              (self.props.default_channel_rate_room_type &&
              channel_rate_room_type &&
              channel_rate_room_type.default
                ? "default-channel "
                : " ")
            }
          >
            <div className="controls">
              <div className="form-group">
                <label>
                  {I18n.t("status")}{" "}
                  <span
                    className="ss-help help"
                    title={I18n.t("channel_disabled_rate_room_type")}
                  ></span>
                </label>
                <select
                  className="form-control"
                  onChange={self.onChangeDisabled.bind(
                    this,
                    rate.id,
                    room_type.id
                  )}
                  value={
                    channel_rate_room_type && channel_rate_room_type.status
                      ? channel_rate_room_type.status
                      : "disabled"
                  }
                >
                  <option value="disabled">{I18n.t("disabled")}</option>
                  <option value="enabled">{I18n.t("enabled")}</option>
                </select>
              </div>
              {self.props.default_channel_rate_room_type ? (
                <div className="form-group">
                  <label>
                    {I18n.t("default")}{" "}
                    <span
                      className="ss-help help"
                      title={I18n.t("channel_default_rate_room_type")}
                    ></span>
                  </label>
                  <Switch
                    switchId={rate.id + "_" + room_type.id + "_default"}
                    onText="yes"
                    offText="no"
                    value={
                      channel_rate_room_type && channel_rate_room_type.default
                        ? true
                        : false
                    }
                    onChange={self.onChangeDefault}
                    rateID={rate.id}
                    roomTypeID={room_type.id}
                    customChangeHandlerRequired="channelSwitches"
                  />
                </div>
              ) : null}
            </div>
          </td>
        );
      });

      return (
        <tr key={rate.id}>
          <th className="rate">
            {rate.code} ({rate.name})
          </th>
          {cols}
        </tr>
      );
    });

    return rows;
  }

  /**
   * Change handlers
   */

  onChange(event) {
    var state = Object.assign({}, this.state);
    state[event.target.name] = event.target.value;
    state.loading = true;
    this.setState(state, () => {
      $.ajax({
        type: "POST",
        url: this.props.channel_default_rate_room_type_path,
        data: {
          rate_id: this.state.rate_id,
          room_type_id: this.state.room_type_id,
        },
      }).done((data) => {
        this.setState({ loading: false });
      });
    });
  }

  onChangeActiveTab(active_tab) {
    this.setState({ active_tab: active_tab });
  }

  onChangeDefault(rate_id, room_type_id, value) {
    this.setState({ loading: true });
    $.ajax({
      type: "POST",
      url: this.props.channel_default_path,
      data: {
        rate_id: rate_id,
        room_type_id: room_type_id,
        value: value,
      },
    }).done((data) => {
      this.setState({
        channel_rate_room_types: data.channel_rate_room_types,
        loading: false,
      });
    });
  }

  onChangeDisabled(rate_id, room_type_id, event) {
    this.setState({ loading: true });

    $.ajax({
      type: "POST",
      url: this.props.channel_disabled_path,
      data: {
        rate_id: rate_id,
        room_type_id: room_type_id,
        value: event.target.value === "disabled" ? true : false,
      },
    }).done((data) => {
      this.setState({
        channel_rate_room_types: data.channel_rate_room_types,
        loading: false,
      });
    });
  }

  /**
   * Helper functions
   */

  getChannelRateRoomType(rate_id, room_type_id) {
    for (
      var i = 0, ilen = this.state.channel_rate_room_types.length;
      i < ilen;
      i++
    ) {
      var channel_rate_room_type = this.state.channel_rate_room_types[i];
      if (
        channel_rate_room_type.rate.id == rate_id &&
        channel_rate_room_type.room_type.id == room_type_id
      ) {
        return channel_rate_room_type;
      }
    }
  }

  getTabs() {
    if (this.props.name === "WIHP") {
      var tabs = [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
        {
          tabName: I18n.t("logs"),
          targetName: "logs",
          classes: this.state.active_tab === "logs" ? "active" : null,
          changeHandler: this.onChangeActiveTab,
        },
      ];
      if (!this.props.wihp_active) {
        tabs.splice(-1);
      }
      return tabs;
    }
    return [];
  }
}

export default ChannelBuilder;
